import React from "react";
import { Search } from "@mui/icons-material";
import {
  IconButton,
  TextField,
  InputAdornment,
  Button,
  Box,
  Menu,
  Tooltip,
} from "@mui/material";
import {
  GridToolbarContainer,
  GridToolbarExportContainer,
  GridCsvExportMenuItem,
  GridPrintExportMenuItem,
} from "@mui/x-data-grid";

import FlexBetween from "./FlexBetween";

// Modernized Data Grid Toolbar
const DataGridCustomToolbar = ({ searchInput, setSearchInput, setSearch }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleExportClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleExportClose = () => {
    setAnchorEl(null);
  };

  return (
    <GridToolbarContainer>
      <FlexBetween width="100%">
        {/* Left Side */}
        <Box display="flex" alignItems="center" gap="0.5rem">
          {/* New Export Menu */}
          <Tooltip title="Export">
            <Button variant="outlined" size="small" onClick={handleExportClick}>
              Export
            </Button>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleExportClose}
          >
            <GridToolbarExportContainer>
              <GridCsvExportMenuItem onClick={handleExportClose} />
              <GridPrintExportMenuItem onClick={handleExportClose} />
            </GridToolbarExportContainer>
          </Menu>
        </Box>

        {/* Right Side (search) */}
        <TextField
          label="Search..."
          sx={{ mb: "0.5rem", width: "15rem" }}
          onChange={(e) => setSearchInput(e.target.value)}
          value={searchInput}
          variant="standard"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => {
                    setSearch(searchInput);
                    setSearchInput("");
                  }}
                >
                  <Search />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </FlexBetween>
    </GridToolbarContainer>
  );
};

export default DataGridCustomToolbar;
